<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3494_6264)">
      <path
        d="M8.0026 12.0007C10.2117 12.0007 12.0026 10.2098 12.0026 8.00065C12.0026 5.79151 10.2117 4.00065 8.0026 4.00065C5.79347 4.00065 4.0026 5.79151 4.0026 8.00065C4.0026 10.2098 5.79347 12.0007 8.0026 12.0007Z"
        :fill="color"
      />
      <path
        d="M6.66927 11.773V13.334C6.66927 14.0704 7.26622 14.6673 8.0026 14.6673C8.73898 14.6673 9.33594 14.0704 9.33594 13.334V11.773M8.0026 1.33398V2.00065M2.0026 8.00065H1.33594M3.66927 3.66732L3.26921 3.26725M12.3359 3.66732L12.7361 3.26725M14.6693 8.00065H14.0026M12.0026 8.00065C12.0026 10.2098 10.2117 12.0007 8.0026 12.0007C5.79347 12.0007 4.0026 10.2098 4.0026 8.00065C4.0026 5.79151 5.79347 4.00065 8.0026 4.00065C10.2117 4.00065 12.0026 5.79151 12.0026 8.00065Z"
        :stroke="color"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3494_6264">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  color: {
    type: String,
    default: "#6434D0",
  },
});
</script>
